<template>
  <section class="core-elite">
    <div class="ambient-light"></div>
    <div class="elite-grid"></div>

    <div class="content-wrapper">
      <div class="section-meta">
        <div class="meta-left">
          <span class="line"></span>
          <span class="text">ELITE_SYSTEM_CONTRIBUTORS_2026</span>
        </div>
        <div class="status-pulse">
          <span class="pulse-dot"></span>
          <span class="pulse-text">NODE_STATUS: ENCRYPTED_ACTIVE</span>
        </div>
      </div>

      <div class="elite-layout">
        <div v-for="(item, idx) in talentList" :key="idx" class="elite-member"
          :class="{ 'is-active': activeIndex === idx }" @mouseenter="activeIndex = idx">
          <div class="bg-name">{{ item.enName }}</div>

          <div class="member-inner">
            <div class="energy-axis">
              <div class="axis-glow"></div>
              <div class="axis-point"></div>
            </div>

            <div class="portrait-box">
              <div class="scan-line" v-if="activeIndex === idx"></div>
              <img :src="item.avatar" class="photo" />
              <div class="index-num">NO.0{{ idx + 1 }}</div>

              <div class="frame-decorator top-right"></div>
              <div class="frame-decorator bottom-left"></div>
            </div>

            <div class="info-content">
              <div class="role-tag">{{ item.job }}</div>
              <h3 class="display-name">{{ item.name }}</h3>

              <div class="capability-stats">
                <div v-for="skill in item.desc" :key="skill" class="skill-node">
                  <div class="skill-info">
                    <span class="skill-label">{{ skill }}</span>
                    <span class="skill-val">CORE</span>
                  </div>
                  <div class="skill-bar">
                    <div class="bar-fill"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const activeIndex = ref(0)

// 模拟数据：增加英文名用于背景装饰
const talentList = ref([
  {
    name: "林子淇",
    enName: "LIN ZIQI",
    job: "FOUNDER / ARCHITECT",
    avatar: "https://free-img.400040.xyz/4/2026/03/22/69bf7e108a594.png",
    desc: ["来秋社区创始人", "全栈程序工程师", "AI规划师"]
  },
  {
    name: "王俊超",
    enName: "CHAO WANG",
    job: "FRONTEND DIRECTOR",
    avatar: "https://free-img.400040.xyz/4/2026/03/22/69bf7e108a594.png",
    desc: ["UX_ENGINEERING", "PERFORMANCE"]
  },
  {
    name: "张萌",
    enName: "MONA ZHANG",
    job: "CREATIVE DIRECTOR",
    avatar: "https://free-img.400040.xyz/4/2026/03/22/69bf7e108a594.png",
    desc: ["VISUAL_DNA", "INTERFACE"]
  },
  {
    name: "徐榕斌",
    enName: "ROBIN XU",
    job: "OPERATIONS LEAD",
    avatar: "https://free-img.400040.xyz/4/2026/03/22/69bf7e108a594.png",
    desc: ["GROWTH_LOGIC", "BACKEND"]
  }
])
</script>

<style scoped>
/* 引入高级感字体 */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;400;700;900&family=JetBrains+Mono:wght@200&display=swap');

.core-elite {
  background: #050505;
  min-height: 100vh;
  width: 100%;
  color: #fff;
  font-family: 'Inter', sans-serif;
  position: relative;
  overflow: hidden;
  padding: 120px 0;
}

/* 极简网格底漆 */
.elite-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  mask-image: radial-gradient(circle at center, black, transparent 80%);
}

/* 环境光晕 */
.ambient-light {
  position: absolute;
  top: -10%;
  left: 10%;
  width: 40%;
  height: 40%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.03) 0%, transparent 70%);
  filter: blur(80px);
  pointer-events: none;
}

.content-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 60px;
  position: relative;
  z-index: 2;
}

/* 顶部 Meta 信息 */
.section-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 80px;
}

.meta-left {
  display: flex;
  align-items: center;
  gap: 20px;
  opacity: 0.5;
}

.meta-left .line {
  width: 40px;
  height: 1px;
  background: #fff;
}

.meta-left .text {
  font-size: 10px;
  letter-spacing: 4px;
}

.status-pulse {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  gap: 10px;
}

.pulse-dot {
  width: 6px;
  height: 6px;
  background: #00ff88;
  border-radius: 50%;
  box-shadow: 0 0 10px #00ff88;
  animation: pulse-kf 2s infinite;
}

@keyframes pulse-kf {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}

/* 布局网格 */
.elite-layout {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.elite-member {
  position: relative;
  padding: 40px 0;
  cursor: pointer;
}

/* 背景文字效果 */
.bg-name {
  position: absolute;
  top: 0;
  left: -20px;
  font-size: 7rem;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.01);
  writing-mode: vertical-rl;
  text-transform: uppercase;
  line-height: 1;
  pointer-events: none;
  transition: 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.is-active .bg-name {
  color: rgba(255, 255, 255, 0.04);
  transform: translateY(20px);
}

.member-inner {
  position: relative;
  z-index: 1;
}

/* 侧边能量轴 */
.energy-axis {
  position: absolute;
  left: -15px;
  top: 0;
  width: 1px;
  height: 100%;
  background: rgba(255, 255, 255, 0.05);
}

.axis-glow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  background: linear-gradient(to bottom, transparent, #fff, transparent);
  transition: 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.is-active .axis-glow {
  height: 100%;
}

/* 头像框处理 */
.portrait-box {
  width: 100%;
  aspect-ratio: 0.75;
  background: #111;
  position: relative;
  margin-bottom: 30px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: 0.5s;
}

.is-active .portrait-box {
  border-color: rgba(255, 255, 255, 0.2);
}

.photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.3;
  filter: grayscale(1);
  transition: 0.8s;
}

.is-active .photo {
  opacity: 1;
  filter: grayscale(0);
  transform: scale(1.05);
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #fff, transparent);
  z-index: 5;
  animation: scan-kf 3s linear infinite;
}

@keyframes scan-kf {
  0% {
    top: 0;
  }

  100% {
    top: 100%;
  }
}

.index-num {
  position: absolute;
  right: 15px;
  bottom: 15px;
  font-family: 'JetBrains Mono';
  font-size: 10px;
  opacity: 0.3;
}

/* 装饰线 */
.frame-decorator {
  position: absolute;
  width: 15px;
  height: 15px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  opacity: 0;
  transition: 0.5s;
}

.top-right {
  top: 10px;
  right: 10px;
  border-left: none;
  border-bottom: none;
}

.bottom-left {
  bottom: 10px;
  left: 10px;
  border-right: none;
  border-top: none;
}

.is-active .frame-decorator {
  opacity: 1;
}

/* 文字与能力条 */
.info-content {
  padding-left: 5px;
}

.role-tag {
  font-size: 9px;
  color: #888;
  letter-spacing: 2px;
  margin-bottom: 8px;
}

.display-name {
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 25px 0;
  letter-spacing: -0.5px;
}

.capability-stats {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.skill-info {
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  color: #555;
  margin-bottom: 4px;
}

.skill-bar {
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.05);
  position: relative;
}

.bar-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0;
  background: #fff;
  transition: 1.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.is-active .bar-fill {
  width: 85%;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

/* 响应式 */
@media (max-width: 1200px) {
  .elite-layout {
    grid-template-columns: repeat(2, 1fr);
  }

  .bg-name {
    font-size: 5rem;
  }
}

@media (max-width: 640px) {
  .elite-layout {
    grid-template-columns: 1fr;
  }

  .content-wrapper {
    padding: 0 30px;
  }
}
</style>